module.exports = __webpack_public_path__ + "static/media/yali.13093e53.jpg";